import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import BackendTemplateItem from "../component/backend-gencode/BackendTemplateItem";
import DialogEditTemplate from "../component/backend-gencode/DialogEditTemplate";
import PopUpConfirm from "../component/genaral-component/PopupConfirm";
import { backendTemplateController, fileCodeBackendTemplateController } from "../controller";
import { useCrudHook } from "../helpers/CrudHook";
import { BackendTemplate } from "../model/model/gencode/BackendTemplate";

const useStyle = makeStyles((theme) => ({
	containerTypeBackend: {
		width: 300,
	},
}));
export default function SettingTemplateBackend() {
	const classes = useStyle();
	const crud = useCrudHook<BackendTemplate>({
		controller: backendTemplateController,
		isSetQueryWhenSave: true,
	});
	const  copyTemplate = async (item: BackendTemplate)=> {
		const templateCopy = {...item};
		delete templateCopy.fileTemplates;
		delete templateCopy.id;
		templateCopy.name = `${templateCopy.name} copy` 
		const newTemplate = await backendTemplateController.save(templateCopy);
		for await (const file of item.fileTemplates || []) {
			delete file.id;
			file.templateId = newTemplate.id;
			await fileCodeBackendTemplateController.save(file);
		}
		crud.setQuery({...crud.query})
	}
	return (
		<Grid container>
			<PopUpConfirm
				isDisplay={crud.isShowConfirm}
				onCancel={crud.onCancelConfirm}
				onDelete={() => {
					crud.onDelete(crud.itemSelected);
				}}
			/>
			<Button
				onClick={(e) => {
					crud.onShowPopup({});
				}}
				color={"primary"}
			>
				New
			</Button>
			<DialogEditTemplate
				isDisplay={crud.isShowPopup}
				item={crud.itemSelected}
				onCancel={crud.onCancelPopup}
				onEdit={crud.onSave}
			></DialogEditTemplate>
			{crud.pagingList?.rows?.map((item) => (
				<BackendTemplateItem
					item={item}
					onDelete={crud.onConfirm}
					onEdit={crud.onShowPopup}
					copyItem = {copyTemplate}
				/>
			))}
		</Grid>
	);
}
